var DoT = require('dot');
var {getCoupon} = require('./coupon_common');
//
window.isOw = 1;
module.exports = {
	bindEvent:function(){
		var _that = this;
		// 优惠券领取事件
		  $('.coupon-wrap--active').click(getCoupon);
	},
	getCouponListData:function(params,callback){
		$.ajax({
	        url: '//event.midea.cn/promote/w/mabapp/get_coupon_list_by_bids',
	        'type': 'GET',
	        'data': params,
	        'dataType': 'jsonp',
	        'timeout': 10000,
	        success(res) {
	            console.log(res);
	            if (res.errcode == 0) {	
	                callback && callback(res.data);
	            }else{
	            	alert('query user info fail');
	            }
	        }
	    });

	},
	renderData(){
		var _that = this;
		$('.couponlistTpl').each(function(index,item){
			let batch_ids = $(item).parents('.floor_content').find('.widget-couponlist').attr('data-batch-ids');
			let params = {
				batch_ids:batch_ids
			};
			_that.getCouponListData(params,function(res){

				$(item).parents('.floor_content').find('.widget-couponlist').html(DoT.template($(item).html())({data:res}));
				if(index == $('.couponlistTpl').length-1){//最后一个加载完绑定事件
					_that.bindEvent();
				}

			})
			
		})
	},
	init(){
		this.renderData();

	}
}


// WEBPACK FOOTER //
// ./module/widget.couponlist.js